import { useMediaSettings } from "@/react/components/shared/MediaPlayer/hooks/useMediaSettings";

interface UseMediaConfigProps {
  isDownloadable?: boolean;
  mediaTranscriptId?: number;
  posterUrl?: string;
  signedId: string;
}

interface UseMediaConfigReturn {
  isDownloadable?: boolean;
  mediaTranscriptId?: number;
  posterUrl?: string;
}

export const useMediaConfig = ({
  isDownloadable,
  mediaTranscriptId,
  posterUrl,
  signedId,
}: UseMediaConfigProps): UseMediaConfigReturn => {
  const { mediaSettings } = useMediaSettings(signedId);

  return {
    mediaTranscriptId: mediaSettings?.transcript?.id ?? mediaTranscriptId,
    isDownloadable: mediaSettings?.make_downloadable ?? isDownloadable,
    posterUrl:
      mediaSettings?.custom_thumbnail_url ??
      mediaSettings?.default_thumbnail_url ??
      posterUrl,
  };
};
